import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTagsData } from "modules/Tags/hooks/useTagsData";
import { Tags } from "modules/Tags/tags";
import { SelectWithSearch } from "shared/components/SelectWithSearch/SelectWithSearch";
import { surveyTagsClient } from "modules/Tags/client/surveyTagsClient";
import { useQueryClient } from "react-query";
import { cacheKeys } from "config";

export const TagsField = (props: TagsFieldProps) => {
  const { surveyId, value } = props;
  const queryClient = useQueryClient();
  const { tags, isLoadingTags } = useTagsData();

  const [search, setSearch] = useState<string>("");
  const [selectedTags, setSelectedTags] = useState<Tags.Tag[]>(value);
  const filteredTags = useMemo(
    () => tags.filter((tag) => tag.name.toLowerCase().includes(search.toLowerCase())),
    [search, tags]
  );

  const handleTagsChange = useCallback((changedTags: Tags.Tag[]) => {
    setSelectedTags(changedTags);
    surveyTagsClient.setSurveyTags(surveyId, changedTags.map((tag) => String(tag.name)));
    queryClient.invalidateQueries(cacheKeys.surveys.getSurveys);
  }, [queryClient, surveyId]);

  useEffect(() => {
    setSelectedTags(value);
  }, [value]);

  return (
    <SelectWithSearch
      isLoading={isLoadingTags}
      options={filteredTags}
      value={selectedTags}
      multiple
      onChange={(options) => handleTagsChange(options as Tags.Tag[])}
      onInputChange={setSearch}
      label="tags"
    />
  );
};

interface TagsFieldProps {
  surveyId: string | number;
  value: Tags.Tag[];
}
